import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { withTranslation } from "react-i18next";
import { Button } from "antd";
import { useTranslation } from "react-i18next";
import { useLocation} from "react-router-dom";
import { history } from '_helpers/history'

import NavbarNoLogin from "../../components/Header/Navbars/NavbarNoLogin";
import AuthBg from "../../components/background/AuthBg";
import {xcService} from "../../_services/xcService";


function useQuery() {
  const { search } = useLocation();

  return React.useMemo(() => new URLSearchParams(search), [search]);
}

function ActivateCenter(props) {
  let query = useQuery();
  const dispatch = useDispatch();
  const { t, i18n } = useTranslation();
  const [loading, setLoading] = useState(false);

  const tokenActivation = query.get("token");

  const [errorActivation, setErrorActivation] = useState(false);
  useEffect(() => {
    setErrorActivation(false)
   xcService.post("/v1/center/activate/" + tokenActivation).then(data => {
     if (data.status === 200){

     }else{
       setErrorActivation(true)
     }
   })

  }, []);


  return (
    <>
      <div className="containerRowRegister">
        <NavbarNoLogin className="menuNavRegister"/>


        <div className="colRegister leftRegister">
          <h1>{t("welcome")}</h1>

          <AuthBg/>

        </div>
        <div className="colRegister rightRegister">
          <div className="headerMobile">
            <h1>{t("welcome")}</h1>

          </div>

          <div className="containerRegister">
            {!errorActivation &&
                <div className="centerRegister">
                  <div className={"steps is-scrollable is-scrollable--center-end"}>
                    <div className={"contratoEnviado"}>
                      <h3>{t("registercenter.cuentavalidada")}</h3>
                      <p dangerouslySetInnerHTML={{__html: t('registercenter.subcuentavalidada')}}/>
                      <div style={{ marginTop: 10 }}>
                        <Button style={{margin: "auto"}}
                            onClick={() => history.push("/auth/login")}
                            type={"primary"}
                            className="primaryButton buttonSizeXXL"
                        >
                          {t("menu.inicia")}
                        </Button>
                      </div>
                    </div>
                  </div>
                </div>
            }
            {errorActivation &&
                <div className="centerRegister">
                  <div className={"steps is-scrollable is-scrollable--center-end"}>
                    <div className={"contratoEnviado"}>
                      <h3>{t("registercenter.errorvalidando")}</h3>
                      <p dangerouslySetInnerHTML={{__html: t('registercenter.suberrorvalidando')}}/>
                      <div style={{ marginTop: 10 }}>
                        <Button style={{margin: "auto"}}
                          onClick={() => history.push("/default/index")}
                          type={"primary"}
                          className="primaryButton buttonSizeXXL"
                      >
                        {t("menu.inicio")}
                      </Button>
                      </div>
                    </div>
                  </div>
                </div>
            }
          </div>
        </div>
      </div>
    </>
  );
}
export default withTranslation()(ActivateCenter);
